/* eslint-disable react-hooks/rules-of-hooks */
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingWorkspacesSelector, userRoleSelector, userWorkspacesSelector } from '../redux/selectors';
import { useEffect } from 'react';
import { TUserWorkspace } from 'src/interfaces/workspacesReduxShapes';
import { getUserWorkspaces } from 'src/redux/actions/workspacesActions';
import { ACCOUNT_ROLES } from 'src/constants/globalConstants';

export const getUserWorkspacesHook = (): {
  userWorkspaces: TUserWorkspace[];
  isLoading: boolean;
} => {
  const dispatch = useDispatch();
  const userWorkspaces = useSelector(userWorkspacesSelector);
  const isLoading = useSelector(isLoadingWorkspacesSelector);
  const userRole = useSelector(userRoleSelector);

  useEffect(() => {
    if (userRole !== ACCOUNT_ROLES.USER) return;

    dispatch(getUserWorkspaces());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRole]);

  return { userWorkspaces, isLoading };
};
